import * as React from 'react';

export const AppPermissionContext = React.createContext<string | undefined>(undefined);
